import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import SummaryMetricsTPOUserAdoption from 'containers/UserBehaviorEngagement/TPO/SummaryMetricsTPOUserAdoption';
import UserPersona from 'containers/UserBehaviorEngagement/TPO/UserPersona';
import SummaryMetricsTPOValueCreation from '@containers/ValueCreationMetrics/TPOValueCreation/SummaryMetricsTPOValueCreation';

const scorecards: OverviewComponentType[] = [
  () => <SummaryMetricsTPOValueCreation title="Reach" />,
  () => <SummaryMetricsTPOUserAdoption title="User Adoption" />,
  () => <UserPersona title="User Behavior & Engagement" />,
];

const customOverview: OverviewComponentType | null = null;

const tpoRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default tpoRegistry;
